import * as React from "react";
import type { SVGProps } from "react";
const SvgCursor = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 466.73 533.32" {...props}>
    <path
      fill="#72716d"
      d="m233.37 266.66 231.16 133.46a16.45 16.45 0 0 1-6.03 6.03L242.44 530.89a18.14 18.14 0 0 1-18.14 0L8.24 406.15a16.45 16.45 0 0 1-6.03-6.03z"
    />
    <path
      fill="#55544f"
      d="M233.37 0v266.66L2.21 400.12C.79 397.66 0 394.82 0 391.88V141.44c0-5.89 3.14-11.32 8.24-14.27L224.29 2.43C227.1.81 230.23 0 233.36 0z"
    />
    <path
      fill="#43413c"
      d="M464.52 133.2a16.45 16.45 0 0 0-6.03-6.03L242.43 2.43C239.63.81 236.5 0 233.37 0v266.66l231.16 133.46c1.42-2.46 2.21-5.3 2.21-8.24V141.44c0-2.95-.78-5.77-2.21-8.24z"
    />
    <path
      fill="#d6d5d2"
      d="M448.35 142.54c1.31 2.26 1.49 5.16 0 7.74L238.52 513.7c-1.41 2.46-5.16 1.45-5.16-1.38V272.84c0-1.91-.51-3.75-1.44-5.36l216.42-124.95h.01Z"
    />
    <path
      fill="#fff"
      d="M448.35 142.54 231.93 267.49a10.7 10.7 0 0 0-3.92-3.92L20.62 143.83c-2.46-1.41-1.45-5.16 1.38-5.16h419.65c2.98 0 5.4 1.61 6.7 3.87"
    />
  </svg>
);
export default SvgCursor;
